import React from 'react'

export default function RadioInput(props) {
    function handleClick(value) {
        console.log("Clicked")
        props.onChange({
            target: {
                name: props.name,
                value: value,
                type: "radio"
            }
        })
    }

    const optionClassName = `RadioInput--option-container${props.formData.error.questions[props.questionNum] ? " is-error" : ""}`
    const answer = props.formData.questions[props.questionNum].answer

    const labelId = `${props.name}-label`

    return (
        <div className="RadioInput" role="radiogroup" aria-labelledby={labelId} tabIndex={-1 /* focused when shown alone on phones */}>
            <p className="RadioInput--question" id={labelId}>I see myself as someone who</p>
            <div className="RadioInput--options">
                {["optiona", "optionb"].map((option) => (
                    <div className={`${optionClassName}${answer === option ? " is-selected" : ""}`} onClick={() => handleClick(option)} key={option}>
                        <div className="RadioInput--content-container">
                            <input
                                className="RadioInput--input"
                                type="radio"
                                id={`${props.name}-${option}`}
                                name={`${props.name}`}
                                value={option}
                                onChange={props.onChange}
                                checked={answer === option}
                            />
                            <label className="RadioInput--label" htmlFor={`${props.name}-${option}`}>{props[option]}</label>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}